import { brighten, getFromColorMap, splitColor, } from '@wix/thunderbolt-commons/dist/color';
export const getBrightnessCSSVars = ({ styleProperties, siteColors, paramName = 'shc', fallbackName = 'bg', alpha = 0.5, mutatedParamName, }) => {
    const param = styleProperties[paramName] || styleProperties[fallbackName];
    if (!param) {
        return {};
    }
    const paramValue = getFromColorMap(param, siteColors) || param;
    return {
        [`--${mutatedParamName || paramName}-mutated-brightness`]: splitColor(brighten(getFromColorMap(paramValue), alpha)),
    };
};
//# sourceMappingURL=color.js.map